import { render, staticRenderFns } from "./purchases-order.vue?vue&type=template&id=385f76dc&scoped=true"
import script from "./purchases-order.vue?vue&type=script&lang=js"
export * from "./purchases-order.vue?vue&type=script&lang=js"
import style0 from "./purchases-order.vue?vue&type=style&index=0&id=385f76dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385f76dc",
  null
  
)

export default component.exports